export default "__VITE_PUBLIC_ASSET__d2d0e4f1__"